/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 組織情報のリスト
 * @export
 * @interface GetOrganizations200ResponseInner
 */
export interface GetOrganizations200ResponseInner {
    /**
     * 所属数
     * @type {number}
     * @memberof GetOrganizations200ResponseInner
     */
    affiliationCount: number;
    /**
     * 組織コード
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    organizationCode: string;
    /**
     * 組織名
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    organizationName: string;
    /**
     * グループID
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    companyCode?: string;
    /**
     * 無線グループ名
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    groupName?: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    companyId?: string;
    /**
     * 会社名
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    companyName?: string;
    /**
     * 営業所ID
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    salesOfficeId?: string;
    /**
     * 組織名
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    salesOfficeName?: string;
}

/**
 * Check if a given object implements the GetOrganizations200ResponseInner interface.
 */
export function instanceOfGetOrganizations200ResponseInner(value: object): value is GetOrganizations200ResponseInner {
    if (!('affiliationCount' in value) || value['affiliationCount'] === undefined) return false;
    if (!('organizationCode' in value) || value['organizationCode'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    return true;
}

export function GetOrganizations200ResponseInnerFromJSON(json: any): GetOrganizations200ResponseInner {
    return GetOrganizations200ResponseInnerFromJSONTyped(json, false);
}

export function GetOrganizations200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizations200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'affiliationCount': json['affiliation_count'],
        'organizationCode': json['organization_code'],
        'organizationName': json['organization_name'],
        'companyCode': json['company_code'] == null ? undefined : json['company_code'],
        'groupName': json['group_name'] == null ? undefined : json['group_name'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'salesOfficeId': json['sales_office_id'] == null ? undefined : json['sales_office_id'],
        'salesOfficeName': json['sales_office_name'] == null ? undefined : json['sales_office_name'],
    };
}

export function GetOrganizations200ResponseInnerToJSON(json: any): GetOrganizations200ResponseInner {
    return GetOrganizations200ResponseInnerToJSONTyped(json, false);
}

export function GetOrganizations200ResponseInnerToJSONTyped(value?: GetOrganizations200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'affiliation_count': value['affiliationCount'],
        'organization_code': value['organizationCode'],
        'organization_name': value['organizationName'],
        'company_code': value['companyCode'],
        'group_name': value['groupName'],
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'sales_office_id': value['salesOfficeId'],
        'sales_office_name': value['salesOfficeName'],
    };
}

